import axios from 'axios'

export const fetchStates = async () => {
  const baseURL = window.location.origin
  const { data } = await axios.get(
    `${baseURL}/api/v1/dealer/smart_price_config/`
  )
  return data
}
